import type {
    IMigrationProgress,
    IMigrationRequest,
    IMigrationResponse,
    IMigrationStatus,
    IOrganizationScheduledMigrationStats,
    IRegionsPerService,
    IRetryMigrationRequest,
} from '../../common/interfaces/gws';
import {
    axiosDelete,
    get,
    post,
    put,
} from '../utility/Requests';

export const GWS_SCHEDULE_BASE_PATH = '/gws_/api/move/schedule';

export function scheduleOrganizationMove(scheduleMoveRequest: IMigrationRequest, organizationId: string): Promise<IMigrationResponse> {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}`;
    return post<IMigrationResponse>(requestUrl, {
        body: scheduleMoveRequest,
        stripPortalPath: true,
        ignoreBasePath: true,
    });
}

export const cancelOrganizationMove = async (organizationId: string) => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}`;
    return axiosDelete(requestUrl, {
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};

export const getOrganizationMigrationStatus = async (organizationId: string): Promise<IMigrationStatus> => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}`;
    return get<IMigrationStatus>(requestUrl, {
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};

export const getAvailableRegionsPerService = async (organizationId: string): Promise<IRegionsPerService> => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}/RegionsPerService`;
    return get<IRegionsPerService>(requestUrl, {
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};

export const getOrganizationScheduledMigrationStats = async (organizationId: string): Promise<IOrganizationScheduledMigrationStats> => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}/ScheduledMigrationsStats`;
    return get<IOrganizationScheduledMigrationStats>(requestUrl, {
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};

export const getOrganizationMigrationProgress = async (organizationId: string): Promise<IMigrationProgress> => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}/progress`;
    return get<IMigrationProgress>(requestUrl, {
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};

export const updateOrganizationSchedule = async (organizationId: string, request: IMigrationRequest): Promise<void> => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}`;
    return put(requestUrl, {
        body: request,
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};

export const retryOrganizationMigration = async (organizationId: string, request: IRetryMigrationRequest): Promise<void> => {
    const requestUrl = `${GWS_SCHEDULE_BASE_PATH}/${organizationId}/retry`;
    return post(requestUrl, {
        body: request,
        stripPortalPath: true,
        ignoreBasePath: true,
    });
};
